import { Autocomplete, TextField } from "@mui/material";
import { FILTER_FIELD_SX, PopperAjustado } from "../../Apuracoes/components/SelectFiltro";
import { STATUS_LABEL, formatarData } from "../utils/projeto.util";

const rotuloProjeto = (projeto) =>
  `${projeto.codigo} · ${STATUS_LABEL[projeto.status] || projeto.status} · ${formatarData(projeto.dtCriacao)}`;

/**
 * TXM-558 — "Projetos deste cliente": escolher um projeto abre a apuração com os filtros salvos
 * dele (e, se aprovado, no modo consulta). Volta ao placeholder depois de escolher.
 * Autocomplete no mesmo padrão visual dos demais filtros do sistema (SelectFiltro).
 */
export default function SeletorProjetosCliente({ projetos = [], onSelecionar }) {
  return (
    <Autocomplete
      size="small"
      blurOnSelect
      value={null}
      options={projetos}
      disabled={projetos.length === 0}
      onChange={(_, projeto) => {
        if (projeto) onSelecionar?.(projeto);
      }}
      getOptionLabel={rotuloProjeto}
      isOptionEqualToValue={(a, b) => a?.idProjeto === b?.idProjeto}
      noOptionsText="Nenhum projeto"
      renderInput={(params) => <TextField {...params} label="Projetos deste cliente" />}
      PopperComponent={PopperAjustado}
      sx={{ ...FILTER_FIELD_SX, width: "280px" }}
    />
  );
}
